export const Capitalize = (v = "") => {
  let arr = v?.toString()?.split(" ");
  arr = arr?.map(
    (string) => string.charAt(0).toUpperCase() + string.slice(1)?.toLowerCase()
  );
  return arr?.join(" ");
};

export function cleanString(str: string, noTrim = false, noCapitalize = false) {
  if (!str) return "";

  // Remove non-letter characters except spaces
  str = str.replace(/[^a-zA-Z\s]/g, "");

  if (!noTrim) str = str.trim();

  if (noCapitalize) return str;

  return smartCapitalize(str);
}

// Capitalizes first letters but preserves acronyms
function smartCapitalize(str: string) {
  return str
    .split(/\s+/)
    .map((word) => {
      // Preserve acronyms (2+ uppercase letters)
      if (/^[A-Z]{2,}$/.test(word)) return word;
      // Normal capitalization (e.g. "impact" → "Impact")
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

export function cleanStringForDot(
  str: string,
  noTrim = false,
  noCapitalize = false
) {
  // Remove non-word characters (excluding whitespace)
  str = str?.split(".")?.slice(1)?.join("");
  str = noTrim ? str : str?.trim();
  return noCapitalize ? str : Capitalize(str);
  // Hello, 123!@#" => Output: "Hello"
}

export function cleanTaggedText(input: string) {
  return input
    ?.replace(/^(\d+\.)?/, "") // Remove leading number and dot
    ?.replace(/_/g, " ") // Replace underscores with spaces
    ?.trim();
}

export function areArraysIdentical(arr1 = [] as any[], arr2 = [] as any[]) {
  if (arr1?.length !== arr2?.length) {
    return false; // If lengths are not equal, arrays cannot be identical
  }
  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return sortedArr1.every((value, index) => value === sortedArr2[index]);
}
